import { Switch } from '@mui/material'
import { styled } from '@mui/system'

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 21,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(14px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#4caf50',
        ...(theme.palette.mode === 'dark' && {
          backgroundColor: '#388e3c',
        }),
      },
      '&.Mui-disabled': {
        // Fix: Target the switch base when checked *and* disabled
        color: theme.palette.grey[500], // Switch icon color when disabled
      },
    },
    '&.Mui-disabled': {
      color: theme.palette.grey[500], // Switch icon color when disabled, if not checked
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 18,
    height: 18,
    borderRadius: 9,
    transition: theme.transitions?.create(['width'], {
      duration: 200,
    }),
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[400], // Thumb color when disabled
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...(theme.palette.mode === 'dark' && {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
    '&.Mui-disabled': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      backgroundColor: theme.palette.grey[500], // Track color when disabled
    },
  },
  '&.Mui-disabled': {
    opacity: 0.5,
  },
  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[500],
    opacity: 0.5,
  },
}))
